import { useMemo } from 'react';
import pluralize from 'pluralize';

export const getHiresHeader = (hiresCount) => `${hiresCount?.toLocaleString()} ${pluralize('hire', hiresCount ?? 0)}`;

export const useHiresColumns = ({ hiresTotal = 0, isLoading = false } = {}) =>
  useMemo(
    () => [
      {
        Header: isLoading ? 'Loading...' : getHiresHeader(hiresTotal),
        accessor: 'contact',
        width: 200,
        hide: false,
        pinned: 'left',
        cellRenderer: 'hireContactRenderer',
        suppressMovable: true,
        disableSortBy: true,
        show: true,
        hideOnTableColumn: true,
        valueFormatter: ({ data: { original } }) => original.contact?.fullName || '',
      },
      {
        Header: 'Company',
        accessor: 'company',
        width: 200,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'hireCompanyRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.organization?.name || '',
      },
      {
        Header: 'Job title',
        accessor: 'jobTitle',
        width: 240,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'hireJobTitleRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.jobTitle || '',
      },
      {
        Header: 'Assisted by team',
        accessor: 'teamInvolvement',
        width: 160,
        disableSortBy: false,
        disablePadding: true,
        cellRenderer: 'hireTeamInvolvementRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.teamInvolvement || '',
      },
      {
        Header: 'Hired date',
        accessor: 'hiredDate',
        width: 160,
        disableSortBy: false,
        disablePadding: true,
        cellRenderer: 'hireDateRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => original.dateFrom || '',
      },
      {
        Header: 'Source',
        accessor: 'source',
        width: 200,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'contactSourceRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => {
          const sources = original.contact?.importers?.map((importer) => importer.name) || [];
          return sources.join(', ') || '';
        },
      },
      {
        Header: 'Contact of',
        accessor: 'contactOf',
        flex: 1,
        minWidth: 240,
        disableSortBy: true,
        disablePadding: true,
        cellRenderer: 'contactOfRenderer',
        show: true,
        valueFormatter: ({ data: { original } }) => {
          const contactOf = original.contact?.importers || [];
          return contactOf.map((of) => of.name).join(', ') || '';
        },
      },
    ],
    [],
  );
